import styled from "styled-components"

export const ContactCardContainer = styled.div`
    // contact cards at the top of profiles need to be moved up
    // to account for the extra space introduced by their lineheight
    // without changing the bottom margin of the navigation tabs
    margin-top: -8px;

    margin-bottom: -4px;
`
